import { Row, Space, Button, Col, Menu, Dropdown } from 'antd';
import {
    PlusCircleFilled, MinusCircleFilled, DownOutlined, DownloadOutlined, UploadOutlined,
    TagsOutlined, DollarOutlined
} from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { ExecelTaxInvoiceInfo, MakeTaxInvoice, getBankAccount, getBase64Statement, getBillDetail, getFinancialbalance, getLabList, getMachineList, getTaxInfoLabIds, getlabtaxInfo } from '../../api/api';
import CustomTable from '../../components/_common/Table';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { errorNotify, sucessNotify } from '../../services/toast.notification';
import { ButtonContainer, LabListContainer, SumContainer } from './style';
import { UpdateLabList } from '../../redux/reducers/lablistSlice';
import { ManualPaymentdialog } from './ManualPaymentdialog';
import { UploadInvoiceDialog } from './uploadInvoiceDialog';
import { GenerateNewBillDialog } from './GenerateNewBillDialog';
import CustomSelectAntDesign from '../../components/_common/CustomSelectAntDesign';
import { ConfigProvider } from "antd";
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import 'dayjs/locale/fa';
import { UpdateTaxList } from '../../redux/reducers/FinancialBalanceSlice';
import { login } from '../../redux/reducers/authSlice';
import ConvertToExcel from '../../components/_common/Excel/ConvertToExcel';
import DownloadPdfFile from '../../components/_common/DownloadZipFile/PdfFile';
import moment from 'moment';
import React from 'react';
import toast from 'react-hot-toast';


const FinancialBalance = () => {

    const myStore = useAppSelector((state) => state)
    const [isLoading, setIsLoading] = useState(true);
    const [financialList, setFinancialList] = useState<any[]>([]);
    const [labList, setLabList] = useState<any[]>([]);
    const [selectedLab, setSelectedLab] = useState("0");
    const [showUploadDialog, setShowUploadDialog] = useState(false);
    const [uploadDialogPayload, setUploadDialogPayload] = useState({ labId: 0, payId: 0, billNumber: 0, date: '' });
    const [debtor, setdebtor] = useState(0);
    const [creditor, setCreditor] = useState(0);
    const [reminder, setReminder] = useState(0);
    const [showPaymentDialog, setShowPaymentDialog] = useState(false);
    const [paymentDialogPayload, setPaymentDialogPayload] = useState({ requestid: 0, machineName: "", bill: undefined, bankAccount: undefined });
    const [showGenerateBillDialog, setShowGenerateBillDialog] = useState(false);
    const [generateBillDialogPayload, setGenerateBillDialogPayload] = useState({ labId: 0 });
    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    const [labTaxInfo, setLabTaxInfo] = useState<any>();
    const [excelData, setExcelData] = useState<any>();
    const [excelErr, setExcelErr] = useState<any>();
    const [permission, setPermission] = useState(false);


    const columns: ColumnsType<any> = [
        {
            title: '-', dataIndex: 'bill', key: 'bill', render: (_, record) => (
                <Space size="middle">
                    {permission && record.bill === 0 ? <PlusCircleFilled disabled={!permission} style={{ color: 'Green', fontSize: '18px' }} /> : permission && <MinusCircleFilled disabled={!permission} style={{ color: 'red', fontSize: '18px' }} />}
                </Space>
            )
        },
        { title: 'عنوان تراکنش', dataIndex: 'str_Title', key: 'str_Title' },
        { title: 'ساعت تراکنش', dataIndex: 'str_TrsDateTime', key: 'str_TrsDateTime' },
        { title: 'نوع تراکنش', dataIndex: 'str_TrsType', key: 'str_TrsType' },
        { title: 'بدهکار', dataIndex: 'str_Debtor', key: 'str_Debtor' },
        { title: 'بستانکار', dataIndex: 'str_creditor', key: 'str_creditor' },
        { title: 'توضیحات', dataIndex: 'str_Description', key: 'str_Description' },
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
    ];

    const menu = (record: any) => (
        <Menu
            items={[
                {
                    key: "1",
                    label: "آپلود فاکتور",
                    onClick: () => uploadInvoice(record.frk_LabID, record.trsAutoID, record.int_TaxBillId, record.str_TaxBuyDate),
                    icon: <UploadOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.bill === 0 && record.bit_HaveInvoice === 0 && record.int_Amount != 0) || !permission

                },
                {
                    key: "2",
                    label: "ویرایش فاکتور",
                    onClick: () => uploadInvoice(record.frk_LabID, record.trsAutoID, record.int_TaxBillId, record.str_TaxBuyDate),
                    icon: <TagsOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.bill === 0 && record.bit_HaveInvoice === 1 && record.int_Amount != 0) || !permission

                },
                {
                    key: "3",
                    label: "پرداخت دستی",
                    onClick: () => manualPaymentOnClick(record.trsAutoID, ""),
                    icon: <DollarOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.bill === 1 && record.int_TotalPay < record.int_Amount) || !permission

                },
                {
                    key: "4",
                    label: "دانلود فاکتور",
                    onClick: () => downloadInvoice(record.frk_LabID,record.trsAutoID),
                    icon: <DownloadOutlined />,
                    disabled: !(record.bill === 0 && record.int_Amount != 0) || !permission
                },

            ]}
        />
    )

    const dispatch = useAppDispatch();
    useJalaliLocaleListener();

    const _getLabTaxInfo = (labId: number) => {
        getlabtaxInfo(labId)
            .then((result: any) => {
                console.log(result);
                setLabTaxInfo(result.data.data);
                dispatch(login({
                    loginType: "parsicuser", userId: myStore.auth.userId, userTitle: myStore.auth.userTitle,
                    taxInfo: result.data.data, permission: myStore.auth.permission,
                    manager: myStore.auth.manager
                    , int_minimumpayment: myStore.auth.int_minimumpayment
                }));
                setShowUploadDialog(true);
                setIsLoading(false);


            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const _ExportToExcell = () => {
        if (firstDate == undefined || lastDate == undefined)
            errorNotify('لطفا بازه زمانی انتخاب نمایید!');
        else {
            ExecelTaxInvoiceInfo(firstDate.format('YYYY-MM-DD'), lastDate.format('YYYY-MM-DD'))
                .then((result: any) => {
                    console.log(result);
                    ConvertToExcel(result.data.data);
                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
                })
        }

    }

    const ExcelTaxInfo = (firstDate: any = undefined, lastDate: any = undefined) => {
        ExecelTaxInvoiceInfo(firstDate, lastDate)
            .then((result: any) => {
                console.log(result);
                setExcelData(result.data.data);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const _MakeTaxInvoice = async () => {

        if (firstDate === undefined || lastDate === undefined)
            errorNotify("برای دانلود فاکتور انتخاب تاریخ الزامیست.");
        else {
            const diff = lastDate.diff(firstDate);
            const Difference_In_Days: any = diff / (1000 * 3600 * 24);
            if (Difference_In_Days > 30)
                errorNotify("بازه زمانی نباید بیشتر از یک ماه باشد.");

            else {
                const toastId = toast.loading('...درحال آماده سازی فایل فاکتور');

                let IDList = getTaxInfoLabIds(myStore.taxList.list);
                let pdfArray: any[] = [];

                MakeTaxInvoice(IDList,0)
                    .then((result: any) => {
                        if (result != "[]" && result != "") {

                            let jsonResult = JSON.parse(result);
                            console.log(jsonResult[0].FileContent);

                            pdfArray.push(`${jsonResult[0].FileContent}`);
                            DownloadPdfFile(pdfArray, "لیست فاکتورها");
                            toast.dismiss(toastId);
                        }
                        else {
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        errorNotify(error.response.data.errorMessage, undefined, 5000)
                    })
            }
        }
    }

    useEffect(() => {

        if (myStore.auth.loginType === 'labuser') {
            loadFinancialBalance(0);
            setPermission(true);
        }
        else {
            if (!myStore.labList.list) {
                loadLabs()
            }
            else {
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list);
                loadFinancialBalance(selectedLab);
            }


            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'financialBalance')
                    setPermission(item.isDetailAccess);
            });

        }


    }, [])

    const loadLabs = () => {
        getLabList()
            .then((result: any) => {
                console.log(result.data.data);
                dispatch(UpdateLabList({ labList: result.data.data }))
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list)
                loadFinancialBalance(0)
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const LabListInitilization = (labItems: any) => {

        let allLabItem = { prk_AndriodLab_AutoID: 0, str_LabPersianName: "همه آزمایشگاه ها" }
        setLabList([allLabItem, ...labItems])

    }

    const loadFinancialBalance = (labId: any, firstDate: any = undefined, lastDate: any = undefined) => {

        setIsLoading(true);

        getFinancialbalance(myStore.auth.loginType === 'labuser' ? myStore.auth.userId : labId, firstDate ? firstDate : getFirstDate(), lastDate ? lastDate : getLastDate())
            .then((result: any) => {
                setFinancialList(result.data.data);
                dispatch(UpdateTaxList({ taxList: result.data.data }));
                briefCalculator(result.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const briefCalculator = (list: any) => {

        if (list != undefined) {

            let value: number = 0;
            let debt: number = 0;
            let pay: number = 0;

            setdebtor(0);
            setCreditor(0);
            setReminder(0);


            list.forEach((element: any) => {
                element.bill === 1 ? debt = debt + element.int_Amount : pay = pay + element.int_Amount;
            });


            setdebtor(debt);
            setCreditor(pay);
            setReminder(debt - pay);

        }
        else {
            setdebtor(0);
            setCreditor(0);
            setReminder(0);
        }

    }

    const uploadInvoice = (labId: any, payId: any, billNum: number, date: any) => {

        setUploadDialogPayload({ ...uploadDialogPayload, labId: labId ? labId : selectedLab, payId: payId, billNumber: billNum, date: date })
        _getLabTaxInfo(labId);
    }

    const downloadInvoice = (labId: any,discount:number) => {
        let pdfArray: any[] = [];
        let IdList: any[] = [];
        IdList.push(labId);

        let toastId: any;

        MakeTaxInvoice(IdList,discount)
            .then((result: any) => {
                if (result != "[]" && result != "") {
                    toastId = toast.loading('...درحال آماده سازی فایل فاکتور');
                    let jsonResult = JSON.parse(result);
                    console.log(jsonResult[0].FileContent);

                    pdfArray.push(`${jsonResult[0].FileContent}`);
                    DownloadPdfFile(pdfArray, "لیست فاکتورها");
                    toast.dismiss(toastId);
                }
                else {
                    toast.dismiss(toastId);

                    errorNotify("فاکتور هنوز به تایید مالی نرسیده است!")
                }




            })
            .catch((error) => {
                // ErrorArray.push(id);
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const manualPaymentOnClick = (BillId: number, machineName: string) => {
        setShowPaymentDialog(true);
        setPaymentDialogPayload((values: any) => ({
            ...values,
            requestid: 0,
            machineName: machineName,
        }));

        getBankAccount()
            .then((result: any) => {

                setPaymentDialogPayload((values: any) => ({
                    ...values,
                    bankAccount: result.data.data,
                }));

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })



        getBillDetail(BillId)
            .then((result: any) => {
                console.log(result.data.data);
                if (result.data.data.length > 0) {

                    setPaymentDialogPayload((values: any) => ({
                        ...values,
                        bill: result.data.data[0],
                    }));

                }

            })
            .catch((error: any) => {
                console.log(error);
                error(error, undefined, 5000)
            })

    }

    const generateNewBill = () => {

        console.log(selectedLab);

        setGenerateBillDialogPayload((values: any) => ({
            ...values,
            labId: Number(selectedLab),
        }));


        setShowGenerateBillDialog(true);
    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {

        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])
        loadFinancialBalance(selectedLab, dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD'));
        //ExcelTaxInfo(dates[0].format('YYYY-MM-DD'),dates[1].format('YYYY-MM-DD'));

    }

    const getFirstDate = () => {
        return firstDate ? firstDate.format('YYYY-MM-DD') : undefined
    }

    const getLastDate = () => {
        return lastDate ? lastDate.format('YYYY-MM-DD') : undefined
    }


    return (

        <>
            {isLoading === false && myStore.auth.loginType === 'parsicuser' && (
                <LabListContainer>

                    <Row>
                        <Col md={6}>
                            <CustomSelectAntDesign
                                name="lab"
                                placeholder="آزمایشگاه"
                                itemList={labList}
                                value={(selectedLab == "" || selectedLab == "0") ? "همه آزمایشگاه ها" : selectedLab}
                                onChange={(x: any) => { setSelectedLab(x); loadFinancialBalance(x); }}
                                valueObjectField={"prk_AndriodLab_AutoID"}
                                displayObjectField={"str_LabPersianName"}
                                showSearch={true}
                            />
                        </Col>
                        <Col md={6} style={{ float: 'left' }}>
                            <>
                                <div className="calender">
                                    <ConfigProvider locale={fa_IR} direction="rtl">
                                        <JalaliLocaleListener />
                                        <DatePickerJalali.RangePicker value={[firstDate, lastDate]} onCalendarChange={(dates: any, dateStrings: any, info: any) => onChangeDatePicker(dates, dateStrings, info)} />
                                    </ConfigProvider>
                                </div>

                            </>
                        </Col>
                        <Col md={6}>
                            <ButtonContainer>
                                <Button disabled={!permission} type="primary" style={{ backgroundColor: "blue" }} onClick={_ExportToExcell}>دانلود اکسل مالیاتی</Button>
                            </ButtonContainer>
                        </Col>
                        <Col md={6}>
                            <ButtonContainer>
                                <Button disabled={!permission} type="primary" style={{ backgroundColor: "blue" }} onClick={_MakeTaxInvoice}>دانلود فاکتور</Button>
                            </ButtonContainer>
                        </Col>
                    </Row>

                    <Row>
                        
                    </Row>

                    <Row>
                        <Col>
                            {selectedLab != "0" && (
                                <Col >
                                    <ButtonContainer>
                                        <Button type="primary" disabled={!permission} style={{ backgroundColor: "Orange" }} onClick={generateNewBill}>فاکتور جدید</Button>
                                    </ButtonContainer>
                                </Col>
                            )}
                        </Col>
                    </Row>


                </LabListContainer>
            )}

            <Row>
                <CustomTable columns={columns} data={myStore.taxList.list} isloading={isLoading} onAddClick={undefined} permission={permission} />
            </Row>

            {isLoading === false && financialList != undefined && (
                <SumContainer>
                    <Row align='middle'>
                        <Col>جمع بدهکار: {debtor.toLocaleString()} </Col>
                    </Row>
                    <Row align='middle'>
                        <Col>جمع بستانکار: {creditor.toLocaleString()} </Col>
                    </Row>
                    <Row align='middle'>
                        <Col>مانده: {reminder.toLocaleString()} </Col>
                    </Row>
                </SumContainer>
            )}


            {showUploadDialog && (
                <UploadInvoiceDialog
                    visible={showUploadDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowUploadDialog(false); loadFinancialBalance(selectedLab); }}
                    payLoad={uploadDialogPayload}
                    setShowDialog={(value) => setShowUploadDialog(value)}
                    loadFinancialBalance={loadFinancialBalance}
                    selectedLab={selectedLab}
                    labTaxInfo={myStore.auth.taxInfo}
                />
            )}

            {showPaymentDialog && (
                <ManualPaymentdialog
                    visible={showPaymentDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowPaymentDialog(false); loadFinancialBalance(selectedLab); }}
                    payLoad={paymentDialogPayload}
                    setShowDialog={(value) => setShowPaymentDialog(value)}
                />
            )}

            {showGenerateBillDialog && (
                <GenerateNewBillDialog
                    visible={showGenerateBillDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowGenerateBillDialog(false); loadFinancialBalance(selectedLab); }}
                    payLoad={generateBillDialogPayload}
                    setShowDialog={(value) => setShowGenerateBillDialog(value)}
                />
            )}

        </>
    );
};

export default FinancialBalance